"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var requests_1 = require("../../app/util/requests");
var actions_1 = __importDefault(require("../../app/components/pages/RootPage/actions"));
var types_1 = require("./types");
var userHasApiKey = function () { return ({
    type: types_1.USER_HAS_API_KEY,
}); };
var userHasNoApiKey = function () { return ({
    type: types_1.USER_HAS_NO_API_KEY,
}); };
var generateApiKeySuccessfully = function (apiKey) { return ({
    type: types_1.GENERATE_API_KEY_SUCCESSFULLY,
    payload: { apiKey: apiKey },
}); };
var openApiKeyModal = function () { return ({
    type: types_1.OPEN_API_KEY_MODAL,
}); };
var closeApiKeyModal = function () { return ({
    type: types_1.CLOSE_API_KEY_MODAL,
}); };
function handleError(dispatch, response) {
    return __awaiter(this, void 0, void 0, function () {
        var responseType, message, json;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    responseType = response.headers.get('content-type');
                    if (!(responseType === null || responseType === void 0 ? void 0 : responseType.includes('json'))) return [3 /*break*/, 2];
                    return [4 /*yield*/, response.json()];
                case 1:
                    json = _a.sent();
                    message = json.message;
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, response.text()];
                case 3:
                    message = _a.sent();
                    _a.label = 4;
                case 4:
                    message = message.replace('Error validating request body. ', '');
                    dispatch(actions_1.default.setErrorMessage(message));
                    return [2 /*return*/];
            }
        });
    });
}
var generateApiKey = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var response, message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, requests_1.postFormData('/api/user/apiKey', new FormData())];
                case 1:
                    response = _a.sent();
                    if (!!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, handleError(dispatch, response)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, response.json()];
                case 4:
                    message = (_a.sent()).message;
                    dispatch(generateApiKeySuccessfully(message));
                    dispatch(openApiKeyModal());
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
var hasApiKey = function () {
    return function (dispatch) {
        requests_1.get('/api/user/hasApiKey').then(function (response) {
            var isOk = response.ok;
            return response.json().then(function (json) {
                if (isOk) {
                    var message = json.message;
                    if (message === 'true') {
                        dispatch(userHasApiKey());
                    }
                    else {
                        dispatch(userHasNoApiKey());
                    }
                }
                else {
                    var errorMessage = 'Error getting user has apiKey';
                    dispatch(userHasNoApiKey());
                    dispatch(actions_1.default.setErrorMessage(errorMessage));
                }
            });
        });
    };
};
exports.default = {
    generateApiKey: generateApiKey,
    hasApiKey: hasApiKey,
    closeApiKeyModal: closeApiKeyModal,
    openApiKeyModal: openApiKeyModal,
};
